// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Presentation,
    Printer,
    PrinterCheck,
    PrinterX,
    Projector,
    Proportions,
    Puzzle,
    Pyramid,
    QrCode,
    Quote,
    Rabbit,
    Radar,
    Radiation,
    Radical,
    Radio,
    RadioOff,
    RadioReceiver,
    RadioTower,
    Radius,
    Rainbow,
    Rat,
    Ratio,
    Receipt,
    ReceiptCent,
    ReceiptEuro,
    ReceiptIndianRupee,
    ReceiptJapaneseYen,
    ReceiptPoundSterling,
    ReceiptRussianRuble,
    ReceiptSwissFranc,
    ReceiptText,
    ReceiptTurkishLira,
    RectangleCircle,
    RectangleEllipsis,
    RectangleGoggles,
    RectangleHorizontal,
    RectangleVertical,
    Recycle,
    Redo,
    Redo2,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "presentation" through "redo-2", inclusive. */
const shard: Record<string, LucideIcon> = {
    presentation: Presentation,
    printer: Printer,
    "printer-check": PrinterCheck,
    "printer-x": PrinterX,
    projector: Projector,
    proportions: Proportions,
    puzzle: Puzzle,
    pyramid: Pyramid,
    "qr-code": QrCode,
    quote: Quote,
    rabbit: Rabbit,
    radar: Radar,
    radiation: Radiation,
    radical: Radical,
    radio: Radio,
    "radio-off": RadioOff,
    "radio-receiver": RadioReceiver,
    "radio-tower": RadioTower,
    radius: Radius,
    rainbow: Rainbow,
    rat: Rat,
    ratio: Ratio,
    receipt: Receipt,
    "receipt-cent": ReceiptCent,
    "receipt-euro": ReceiptEuro,
    "receipt-indian-rupee": ReceiptIndianRupee,
    "receipt-japanese-yen": ReceiptJapaneseYen,
    "receipt-pound-sterling": ReceiptPoundSterling,
    "receipt-russian-ruble": ReceiptRussianRuble,
    "receipt-swiss-franc": ReceiptSwissFranc,
    "receipt-text": ReceiptText,
    "receipt-turkish-lira": ReceiptTurkishLira,
    "rectangle-circle": RectangleCircle,
    "rectangle-ellipsis": RectangleEllipsis,
    "rectangle-goggles": RectangleGoggles,
    "rectangle-horizontal": RectangleHorizontal,
    "rectangle-vertical": RectangleVertical,
    recycle: Recycle,
    redo: Redo,
    "redo-2": Redo2,
};

export default shard;
